import React from "react";
import StdViewAttendance from "../../components/StudentTabs/StudentViewAttendance/StdViewAttendance";

const ViewAttendance = () => {
  return (
    <div>
      <StdViewAttendance/>
    </div>
  );
};

export default ViewAttendance;
